<script>
    export default {
        name: 'CoachingTeaser',
        props: {
            dense: {
                type: Boolean,
                default: false
            },
            fullsize: {
                type: Boolean,
                default: false
            }
        }
    }
</script>

<template>
    <VFlex fill-height class="position-relative" :class="{'vc-teaser--dense': dense, 'vc-teaser--fullsize': fullsize}">
        <VImg :src="require('@assets/images/Scorecards-Teaser.jpg')" height="100%" cover>
            <div class="fill-height bottom-gradient"></div>
        </VImg>
        <div class="vc-teaser__text">
            <h4 class="vc-teaser__subtitle-2 title text-center" :data-bp="$vuetify.breakpoint.name">
                {{ $vuetify.lang.t('$vuetify.teaser.text1') }}
                <br>
                <br>
                {{ $vuetify.lang.t('$vuetify.teaser.text2') }}
                <br>
                {{ $vuetify.lang.t('$vuetify.teaser.text3') }}
                <br>
                {{ $vuetify.lang.t('$vuetify.teaser.text4') }}
                <br>
                {{ $vuetify.lang.t('$vuetify.teaser.text5') }}
                <br>
                {{ $vuetify.lang.t('$vuetify.teaser.text6') }}
            </h4>
        </div>
    </VFlex>
</template>

<style lang="scss" scoped>
    .vc-teaser--fullsize {
        width: 100vw;
        height: 100vh;
    }
    .vc-teaser__text {
        position: absolute;
        bottom: 0;
        width: 100%;
    }
    .vc-teaser__title {
        margin-bottom: 128px;
        color: rgba(255, 255, 255, 1);
    }
    .vc-teaser__subtitle {
        color: rgba(255, 255, 255, 0.87);
    }
    .vc-teaser__subtitle-2 {
        padding: 48px;
        margin-bottom: 64px;
        color: rgba(255, 255, 255, 1);
        &[data-bp="sm"] {
            padding: 12px;
            font-size: 1rem !important;
        }
    }
    .bottom-gradient {
        background-image: linear-gradient(to top, rgba(0, 0, 0, 0.65) 0%, transparent 100%);
    }
    .vc-teaser--dense {
        .vc-teaser__subtitle-2 {
            padding: 12px;
            font-size: 1rem !important;
            line-height: 1.6rem;
        }
        .bottom-gradient {
            background-image: linear-gradient(to top, rgba(0, 0, 0, 0.5) 0%, rgba(0, 0, 0, 0.75) 100%);
        }
    }
</style>
